import data from "../../../data/schema/shared/sharedData";

const cleanDataForSubmission = (values) => {
  let data = values;
  if (data) {
    if (data["section_f"]) {
      data["section_f"].map((o, index) => {
        // apply sort order
        data["section_f"][index]["sort_order"] = index;
        // add appropriate field with YES
        if (data["section_f"][index]["f12a_pwd_number"]) {
          data["section_f"][index]["f12_is_dol_prevailing_wage"] = "YES";
        } else if (data["section_f"][index]["f13a_wage_level"]) {
          data["section_f"][index]["f13_is_oes_prevailing_wage"] = "YES";
        } else if (data["section_f"][index]["f14a_source_type"]) {
          data["section_f"][index]["f14_non_oes_prevailing_wage"] = "YES";
        }

        if (data["section_f"][index]["f14a_source_type"] === "CBA") {
          data["section_f"][index]["f14b_source_year"] =
            data["section_f"][index]["f14b_source_year_cba"];
          delete data["section_f"][index]["f14b_source_year_notcba"];
        } else {
          data["section_f"][index]["f14b_source_year"] =
            data["section_f"][index]["f14b_source_year_notcba"];
          delete data["section_f"][index]["f14b_source_year_cba"];
        }
      });
    }
    //remove Wage calculator fields from submissions and updates
    delete data["OES_state"];
    delete data["OES_date_source"];
    delete data["OES_collection_type"];
    delete data["OES_area"];
    delete data["OES_area_based"];
    delete data["OES_secondary_county"];
    delete data["OES_soc_code"];
    delete data["OES_soc_title"];
    delete data["OES_wage_level"];
    delete data["OES_per"];
    delete data["OES_rd_flag"];
    delete data["OES_highly_comp_flag"];
    // clear out attorney data if user selects "Agent"
    if (data["e1_is_represented"] && data["e1_is_represented"] === "Agent") {
      data["e17_agent_bar_number"] = "";
      data["e18_agent_court_state_id"] = "";
      data["e19_agent_court_name"] = "";
    }

    // clear out agent and attorney data if user selects "None"
    if (data["e1_is_represented"] && data["e1_is_represented"] === "None") {
      data["e2_agent_last"] = "";
      data["e3_agent_first"] = "";
      data["e4_agent_middle"] = "";
      data["e5_agent_address_1"] = "";
      data["e6_agent_address_2"] = "";
      data["e7_agent_city"] = "";
      data["e8_agent_state_id"] = "";
      data["e9_agent_zip"] = "";
      data["e10_agent_country_id"] = "";
      data["e11_agent_province"] = "";
      data["e12_agent_phone"] = "";
      data["e13_agent_phone_ext"] = "";
      data["e14_agent_email"] = "";
      data["e15_agent_firm_name"] = "";
      data["e16_agent_firm_fein"] = "";
      data["e17_agent_bar_number"] = "";
      data["e18_agent_court_state_id"] = "";
      data["e19_agent_court_name"] = "";
    }
  }

  return data;
};

const cleanData = (values) => {
  let filterArray = [
    "_",
    "pages",
    "__typename",
    "_federal_minimum_wage_f11",
    "_state_minimum_wage",
    "_federal_minimum_wage",
    "_section_f_f12_f13_f14_prevailing_wage_question",
    "_section_f_f1_number_workers",
    "_section_f_f2_is_secondary_entity",
    "_section_f_f3_secondary_entity_name",
    "_section_f_f4_work_address_1",
    "_section_f_f5_work_address_2",
    "_section_f_f6_work_city",
    "_section_f_f7_work_county_id",
    "_section_f_f8_work_state_id",
    "_section_f_f9_work_zip",
    "_section_f_f10_nonimmigrant_wage_from",
    "_section_f_f10_nonimmigrant_wage_to",
    "_section_f_f10a_nonimmigrant_wage_per",
    "_section_f_f11_prevailing_wage",
    "_section_f_f11a_prevailing_wage_per",
    "_section_f_f12_is_dol_prevailing_wage",
    "_section_f_f12a_pwd_number",
    "_section_f_f13_is_oes_prevailing_wage",
    "_section_f_f13a_wage_level",
    "_section_f_f13b_source_year",
    "_section_f_f14_non_oes_prevailing_wage",
    "_section_f_f14a_source_type",
    "_section_f_f14b_source_year_cba",
    "_section_f_f14b_source_year_notcba",
    "_section_f_f14c_survey_publisher",
    "_section_f_f14d_survey_name",
    "_section_f___typename",
  ];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });

  // clear out attorney data if user selects "Agent"
  if (data["e1_is_represented"] && data["e1_is_represented"] === "Agent") {
    data["e17_agent_bar_number"] = "";
    data["e18_agent_court_state_id"] = "";
    data["e19_agent_court_name"] = "";
  }

  // clear out agent and attorney data if user selects "None"
  if (data["e1_is_represented"] && data["e1_is_represented"] === "None") {
    data["e2_agent_last"] = "";
    data["e3_agent_first"] = "";
    data["e4_agent_middle"] = "";
    data["e5_agent_address_1"] = "";
    data["e6_agent_address_2"] = "";
    data["e7_agent_city"] = "";
    data["e8_agent_state_id"] = "";
    data["e9_agent_zip"] = "";
    data["e10_agent_country_id"] = "";
    data["e11_agent_province"] = "";
    data["e12_agent_phone"] = "";
    data["e13_agent_phone_ext"] = "";
    data["e14_agent_email"] = "";
    data["e15_agent_firm_name"] = "";
    data["e16_agent_firm_fein"] = "";
    data["e17_agent_bar_number"] = "";
    data["e18_agent_court_state_id"] = "";
    data["e19_agent_court_name"] = "";
  }

  if (values["files"]) {
    for (let j = 0; j < values["files"].length; j++) {
      data["files"][j].size = data["files"][j].size.toString();
      delete data["files"][j].fileTypes;
      data["files"][j].lastModified = data["files"][j].lastModified.toString();
      if (data["files"][j].__typename) {
        delete data["files"][j].__typename;
      }
    }
  }

  if (data["a1_visa_type"]) {
    if (data["a1_visa_type"] !== "H-1B") {
      data["h5_is_appendix_a_completed"] = null;
    }
    if (
      data["a1_visa_type"] === "H-1B" &&
      ((data["h4_exemption_basis"] &&
        data["h4_exemption_basis"] === "$60,000 or higher annual wage") ||
        data["h4_exemption_basis"] === "Both")
    ) {
      data["h5_is_appendix_a_completed"] = "N/A";
    }
    if (
      data["a1_visa_type"] === "H-1B" &&
      data["h4_exemption_basis"] &&
      data["h4_exemption_basis"] ===
        "Master's Degree or higher in related speciality" &&
      data["appendix_a"] &&
      data["appendix_a"].length > 0
    ) {
      data["h5_is_appendix_a_completed"] = "YES";
    }
  }
  if (data["section_f"] && data["section_f"].__typename) {
    delete data["section_f"].__typename;
  }

  if (data["section_f"]) {
    for (let i = 0; i < data["section_f"].length; i++) {
      if (data["section_f"][i].__typename) {
        delete data["section_f"][i].__typename;
      }
      if (
        data["section_f"][i].f7_work_county_id &&
        data["section_f"][i].f7_work_county_id.value
      ) {
        delete data["section_f"][i].f7_work_county_id.__typename;
      }
    }
  }
  if (data && data["appendix_a"] && data["appendix_a"].length > 0) {
    data["appendix_a"].map((x) => {
      delete x.__typename;
      if (x && x["other_official_documents"]) {
        x["other_official_documents"].map((xy) => {
          delete xy.__typename;
        });
      }
      if (x && x["transcript"]) {
        x["transcript"].map((xy) => {
          delete xy.__typename;
        });
      }
      if (x && x["degree_diploma"]) {
        x["degree_diploma"].map((xy) => {
          delete xy.__typename;
        });
      }
    });
  }

  // Cleaning checkboxes from Arrays to String for Section I 9035:
  if (
    data["i1_is_disclosure_place_of_employment"] &&
    Array.isArray(data["i1_is_disclosure_place_of_employment"])
  ) {
    if (data["i1_is_disclosure_place_of_employment"].length === 2) {
      data["i1_is_disclosure_place_of_employment"][0] =
        data["i1_is_disclosure_place_of_employment"][1];
    }
    if (data["i1_is_disclosure_place_of_employment"][0] === "YES") {
      data["i1_is_disclosure_place_of_employment"] = "YES";
    } else {
      data["i1_is_disclosure_place_of_employment"] = "NO";
    }
  }

  if (
    data["i1_is_disclosure_principal_business"] &&
    Array.isArray(data["i1_is_disclosure_principal_business"])
  ) {
    if (data["i1_is_disclosure_principal_business"].length === 2) {
      data["i1_is_disclosure_principal_business"][0] =
        data["i1_is_disclosure_principal_business"][1];
    }
    if (data["i1_is_disclosure_principal_business"][0] === "YES") {
      data["i1_is_disclosure_principal_business"] = "YES";
    } else {
      data["i1_is_disclosure_principal_business"] = "NO";
    }
  }
  //remove wage calculator fields from submissions and updates
  delete data["OES_state"];
  delete data["OES_date_source"];
  delete data["OES_collection_type"];
  delete data["OES_area"];
  delete data["OES_area_based"];
  delete data["OES_secondary_county"];
  delete data["OES_soc_code"];
  delete data["OES_soc_title"];
  delete data["OES_wage_level"];
  delete data["OES_per"];
  delete data["OES_rd_flag"];
  delete data["OES_highly_comp_flag"];
  //========================================
  return data;
};

let recheckOnLoad = [
  {
    page_num: 5,
    machine_name: "section_f",
    validate: function (value) {
      let entries = value.filter(
        (x) =>
          x.f12_f13_f14_prevailing_wage_question ===
          "f13_is_oes_prevailing_wage"
      );
      let expiredEntries = entries.filter(
        (x) => x.f13b_source_year !== data.wageDateSeries
      );
      return expiredEntries && expiredEntries.length > 0 ? true : false;
    },
  },
];

const reCheckFieldsOnLoad = (form_ui, formData) => {
  // re-evaluate form.data.pages_errors but for only form.data.pages_visited?
  for (let check of recheckOnLoad) {
    const shouldReCheckFieldOnLoad = form_ui.pages_visited.includes(
      check.page_num
    );
    if (shouldReCheckFieldOnLoad && formData && check.machine_name) {
      let add_page_to_error = check.validate(formData[check.machine_name]);
      if (add_page_to_error) {
        form_ui.pages_errors = [...form_ui.pages_errors, check.page_num];
      }
    }
  }
};

export { cleanData, cleanDataForSubmission, reCheckFieldsOnLoad };
